import { RowAnimationStyle } from '../empracoTypes';

function getAnimationClass(style: RowAnimationStyle) {
  if (style === RowAnimationStyle.fadeUp) {
    return 'fade-up-animation';
  }

  return 'default-animation';
}

/**
 * @description Adds classes on rows that reaches viewport. Note: the rows are selected through the class "row-parent".
 */
export default function rowAnimation(style: RowAnimationStyle) {
  if (style === RowAnimationStyle.none) {
    return;
  }

  // Skip the first two elements in the list for better CLS score.
  const elements = Array.from(document.querySelectorAll('.row-parent > .container')).slice(2);

  if (elements && elements.length > 0) {
    elements.forEach(element => {
      element.classList.add('will-animate');

      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          element.classList.add(getAnimationClass(style));
        }
      });

      observer.observe( element );
    });
  }
}